<template>
    <page>
        <module :title="id ? '编辑限时折扣活动' : '新建限时折扣活动'">
            <c-form ref="form" unit-width="500">
				<c-title>基础信息</c-title>
				<c-form-item label="活动名称" required>
					<c-input name="activity_name" placeholder="请输入活动名称" maxlength="20"></c-input>
				</c-form-item>
				<c-form-item label="活动时间" required>
					<c-datetime start-name="begin_date" end-name="end_date"range></c-datetime>
				</c-form-item>
				<c-form-item label="活动预告" tip="活动预告期间，商品详情页价格上方将会展示活动标题，开始时间和折扣力度。" required>
					<c-radio-group name="activity_notice" v-model="activityNotice" :options="activityNoticeOptions" ></c-radio-group>
				</c-form-item>
				<c-form-item label="提前预告时间" v-show="activityNotice == 1" required>
					<c-input type="number" decimal="1" :range="[1,240]" v-model="activityNoticeTime" name="activity_notice_time" unit="小时" style="width:120px"></c-input>
				</c-form-item>
				<c-form-item label="活动标签">
					<c-input name="tags"  maxlength="4" placeholder="活动标签名称" ></c-input>
				</c-form-item>
				<c-form-item label="支持定制" required tip="支持定制，则表示定制下单可以享受活动折扣">
					<c-radio-group name="is_custom" v-model="isCustom" :options="isCustomOptions"></c-radio-group>
				</c-form-item>
				<c-form-item label="活动说明">
					<c-input type="textarea" name="activity_remark"></c-input>
				</c-form-item>
				<c-title>活动商品</c-title>
				<!-- <c-form-item label="商品参与方式" required >
					<c-radio-group name="commodity_range" v-model="commodityRange" :options="commodityRangeOption"></c-radio-group>
				</c-form-item> -->
				
				<c-form-item v-show="commodityRange == 1" width="1000">
					<c-button color="gray" @click="$refs.productSelector.open()">添加商品</c-button>

					<c-table ref="productList" :data="productList" :paging="false" border>
						<c-table-column
								label="商品信息"
								name="product_name"
								width="260"
						>
							<template v-slot="{data}">
								<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
								<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
							</template>
						</c-table-column>

						<c-table-column
								label="价格"
								name="product_price"
								width="140"
						>
							<template v-slot="{data}">
							  ￥{{data.product_price_min}}
							  <span v-if="data.product_price_max"> - ￥{{data.product_price_max}}</span>
							</template>
						</c-table-column>

						<c-table-column
								label="折扣"
								width="70"
						>
							<template v-slot="{data}">
								<c-input decimal="1" :range="[0.1,10]" v-model="data.activity_discount" width="80" type="number" style="margin: 0 5px;" unit="折"></c-input>
							</template>
						</c-table-column>

						<c-table-column
								label="促销价"
								name="promotion_price"
								width="140"
						>
							<template v-slot="{data}">
								<c-input v-if="setConfigType == 2" decimal="2"  v-model="data.promotion_price" width="80" type="number" style="margin: 0 5px;" ></c-input>
								<span v-if="setConfigType == 1 && data.activity_discount == 0">0</span>
								<span v-if="setConfigType == 1 && data.activity_discount" >
									￥{{parseFloat(data.product_price_min * data.activity_discount / 10).toFixed(2)}}
									<span v-if="data.product_price_max">
										- ￥{{parseFloat(data.product_price_max * data.activity_discount / 10).toFixed(2)}}
									</span>
								</span>
							</template>
						</c-table-column>

						<c-table-column
								type="button"
								fixed="right"
								label="操作"
								width="70"
						>
							<template v-slot="row">
								<c-table-button @click="deleteProduct(row.data)">删除</c-table-button>
							</template>
						</c-table-column>
					</c-table>
				</c-form-item>
            </c-form>
			<template slot="button">
				<c-button color="main" size="form" @click="submit(1)">确定提交</c-button>
			</template>
        </module>

        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>

    </page>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
    import productSelector from '@/components/service/product_selector.vue'

    export default {
        name: 'limit_time_discount_edit',

        components: {
            productInfo,productSelector
        },

        props: {
            id: String
        },

        data() {
            return {
                commodityRange:1,
                setConfigType:1,
                commodityRangeOption: [
                    {name: '指定商品',value: 1}
                ],
                setConfigOption: [
                    {name: '设置折扣',value: 1},
                    {name: '设置促销价',value: 2}
                ],
                productList: [],
                brandList: [],
                activityNoticeTime: 0,
                activityNotice: 0,
                activityNoticeOptions: [{
						name: '立即预告',
						value: 0
					},{
						name: '不预告',
						value: -1
					},{
						name: '提前预告',
						value: 1
					}
				],
                isCustom:0, /**定制下单是否享受活动价 0：不享受 1：享受*/
                isCustomOptions:[{
						name: '不支持',
						value: 0
					},{
						name: '支持',
						value: 1
				   },
				]
            }
        },

        watch: {
            id() {
                this.getActivityDetail();
            },
            setConfigType(val){
                if(val == 2){
                    this.productList.forEach(item=>{
                        item.activity_discount = '';
                    })
                }else if(val == 1){
                    this.productList.forEach(item=>{
                        item.promotion_price = '';
                    })
                }

            },


        },

        mounted() {
            this.id && this.getActivityDetail();
        },

        methods: {
            getActivityDetail() {
                this.request({
                    url: '/activitySale/detail',
                    data: {
                        id: this.id
                    },
                    loading: true,
                    success: data => {
                        this.$refs.form.set(data);
                        this.productList = data.product_list || [];
                        this.brandList = data.brand_list || [];
                        this.commodityRange = data.commodityRange||1;
                        this.setConfigType = data.set_config_type||1;
                        this.activityNoticeTime = data.activity_notice_time;
                    }
                });
            },
            productSelectHandle(list) {
				list = list.filter(item => {
					return !this.productList.find(row => {
						return row.product_id == item.product_id;
					});
				});
				this.productList = this.productList.concat(list);
            },
			deleteProduct(rowData){
				const index = this.productList.indexOf(rowData);
				this.productList.splice(index, 1);
			},
            submit(state) {
                this.$refs.form.submit({
                    url: this.id ? '/activitySale/edit' : '/activitySale/add',

                    rule: {
                        activity_name: '请填写活动名称',
                        begin_date: '请选择活动时间',
						activity_notice: '请选择通知类型',
						activity_notice_config: [{
						  type: 'function',
						  fun: (val,data) => {
						    //指定商品且设置折扣时判断
						    if(this.activityNotice == 1 && (!data.activity_notice_time || data.activity_notice_time<=0)){
						      return false;
						    }else return true;
						  },
						  message: '请填写提前预告时间'
						}],
                        product_list: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 1){
                                    return this.productList.length;
                                }else return true
                            },
                            message: '请选择活动商品'
                        }],
                        product_config: [{
                            type: 'function',
                            fun: () => {
                                //指定商品且设置折扣时判断
                                if(this.commodityRange == 1 && this.setConfigType == 1){
                                    return !this.productList.find(item => {
                                        return !item.activity_discount;
                                    });
                                }else return true;
                            },
                            message: '请设置活动商品折扣'
                        }],
                        product_config2: [{
                            type: 'function',
                            fun: () => {
                                //指定商品且设置折扣时判断
                                if(this.commodityRange == 1 && this.setConfigType == 2){
                                    return !this.productList.find(item => {
                                        return !item.promotion_price;
                                    });
                                }else return true;
                            },
                            message: '请设置活动商品促销价'
                        }],
                        brand_list: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 2){
                                    return this.brandList.length;
                                }else return true
                            },
                            message: '请选择活动品牌'
                        }],
                        brand_config: [{
                            type: 'function',
                            fun: () => {
                                if(this.commodityRange == 2){
                                    return !this.brandList.find(item => {
                                        return !item.activity_discount;
                                    });
                                }else return true;
                            },
                            message: '请设置活动品牌折扣'
                        }]

                    },

                    dataFormatter: data => {
                        this.id && (data.id = this.id);
						data.commodity_range = 1;
                        data.set_config_type = this.setConfigType;
                        data.product_list = this.productList ? Array.from(this.productList, item => {
                            return {
                                product_id: item.product_id,
                                product_sku: item.product_sku,
                                activity_discount: parseFloat(item.activity_discount),
                                promotion_price: parseFloat(item.promotion_price),

                            }
                        }):[];
                        data.brand_list =this.brandList ? Array.from(this.brandList, item => {
                            return {
                                brand_id: item.id,
                                activity_discount: item.activity_discount,
                            }
                        }):[];
                        return data;
                    },

                    success: (data,obj) => {
                        this.$message({
							type:'success',
                            message: '保存成功'
                        });
                        this.navigateTo('/limit_time_discount');
                    }
                })
            }
        }
    }
</script>